import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Grid,
} from "@material-ui/core";
import ErrorDialogBody from "./ErrorDialogBody";
import SuccessDialogBody from "./SuccessDialogBody";
import { IconX } from "@tabler/icons-react";

interface props {
  isOpen: boolean;
  handleClose: () => void;
  children?: any;
  title: string;
  subtitle?: string;
  textButton?: string;
  handleSubmit?: () => void;
  isLoading?: boolean;
  hideActionButtons?: boolean;
  isError?: boolean;
  errorMessage?: string;
  isSuccess?: boolean;
  successMessage?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

const CustomDialog = ({
  isOpen,
  handleClose,
  title,
  subtitle,
  children,
  handleSubmit,
  isLoading,
  hideActionButtons,
  textButton,
  isError,
  errorMessage,
  isSuccess,
  successMessage,
  maxWidth,
}: props) => {
  if (isSuccess) {
    return (
      <div>
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth={'xs'}
          onClose={handleClose}
        >
          <SuccessDialogBody
            handleClose={handleClose}
            successMessage={successMessage}
          />
        </Dialog>
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        <Dialog
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth={'xs'}
        >
          <ErrorDialogBody
            handleClose={handleClose}
            errorMessage={errorMessage}
          />
        </Dialog>
      </div>
    );
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={maxWidth}
        fullWidth={true}
      >
        <span style={{ position: "absolute", top: 5, right: 5 }}>
          <IconButton onClick={handleClose}>
            <IconX size={30} />
          </IconButton>
        </span>
        <DialogTitle id="alert-dialog-title">
          <Typography
            align="center"
            style={{ fontWeight: "600", fontSize: "20pt" }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {Boolean(subtitle) && (
            <Typography
              variant="subtitle1"
              color="textSecondary"
              style={{ textAlign: "center" }}
            >
              {subtitle}
            </Typography>
          )}
          {children}
        </DialogContent>
        {!hideActionButtons ? (
          <DialogActions style={{ padding: "14px" }}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button
                  size="large"
                  fullWidth
                  variant="text"
                  onClick={handleClose}
                >
                  Cancelar
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  size="large"
                  fullWidth
                  disabled={isLoading}
                  onClick={handleSubmit}
                  variant="contained"
                  color="default"
                  endIcon={
                    isLoading && <CircularProgress size={22} color="inherit" />
                  }
                >
                  {textButton || "Aceptar"}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        ) : (
          <br />
        )}
      </Dialog>
    </div>
  );
};

export default CustomDialog;
